import app from './app'
import common from './common'
import user from './user'
import storage from './storage'
import socket from './socket'
import evt from './evt'
import table from './table'
import edit from './edit'
import charts from './charts'
import lifecycle from './lifecycle'

export default {
  env: window.global.env ?? [],
  app,
  common,
  user,
  storage,
  socket,
  evt,
  table,
  edit,
  charts,
  lifecycle,
}